(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["teck-gallery-compare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('teck-image-compare')) {
  customElements.define('teck-image-compare', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const range = this.querySelector('input');
      const stage = this.querySelector('.teck-gallery-compare__stage');
      const update = () => stage.style.setProperty('--compare-position', range.value + '%');
      range.addEventListener('input', update, options);
      ['pointerdown', 'pointermove', 'touchstart', 'touchmove'].forEach(name => {
        range.addEventListener(name, event => event.stopPropagation(), { ...options, passive: true });
      });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
